import React from "react";
import PropTypes from "prop-types";
import { MenuButton } from "../styles";

OrderedListButton.propTypes = {
  editor: PropTypes.object,
  disabled: PropTypes.bool,
};

export default function OrderedListButton({ editor, disabled = false }) {
  return (
    <MenuButton
      onClick={() => editor.chain().focus().toggleOrderedList().run()}
      className={editor.isActive("orderedList") ? "is-active" : ""}
      disabled={disabled}
    >
      <span className="fas fa-list-ol" />
    </MenuButton>
  );
}
